<template>
    <header
        class="md-header template6"
        :class="[pageClass]"
        v-show="showHeader"
    >
        <div
            ref="nav"
            class="header-container"
            role="navigation"
            :class="{ nosticky: isDetail || !sticky }"
        >
            <div class="social-container">
                <a
                    :href="'tel:' + agent.phone"
                    class="phone-container"
                    target="_top"
                    v-if="agent && agent.phone"
                    rel="noopener noreferrer"
                >
                    <span class="iconfont icon-call-small"></span>
                    <span class="des">{{ $ft.formatPhone(agent.phone) }}</span>
                </a>
                <a
                    v-if="agent && agent.email"
                    :href="'mailto:' + agent.email"
                    class="email-container"
                    rel="noopener noreferrer"
                >
                    <span class="iconfont icon-agent-email"></span>
                    <span class="des">{{ agent.email }}</span>
                </a>
                <div
                    v-if="socialNetworksInfo.length > 0"
                    class="share-container"
                >
                    <a
                        v-for="(social, index) in socialNetworksInfo"
                        :key="social.id + '-' + index"
                        class="share-item"
                        :href="social.url"
                        :aria-label="social.socialNetwork"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i class="iconfont" :class="social.icon"></i>
                    </a>
                </div>
            </div>
            <div class="menu-container">
                <div class="header-bg" :style="{ background: bgColor }"></div>
                <a class="logo" :href="link" rel="noopener noreferrer">
                    <site-img
                        :src="logo || null"
                        :alt="altText || defaultLogoAlt"
                        :style="{ height: size / 100 + 'em' }"
                        :size="100"
                        dir="height"
                        @load="sizeChange"
                    ></site-img>
                </a>
                <a
                    v-if="subLogo"
                    class="logo"
                    style="margin-left: 0"
                    :href="subLogoLink"
                    rel="noopener noreferrer"
                >
                    <site-img
                        :src="subLogo || null"
                        :style="{ height: subLogoSize / 100 + 'em' }"
                        :size="100"
                        dir="height"
                        @load="sizeChange"
                        :alt="subAltText || defaultSublogoAlt"
                    ></site-img>
                </a>
                <div class="nav-container" :style="mainText">
                    <ul class="head-menu">
                        <menu-item
                            v-for="(menu, index) in outMoreMenus"
                            :key="menu.name + index"
                            :menu="menu"
                            :showMenuArrow="true"
                            arrowIcon="icon-fashion-down"
                        ></menu-item>
                        <li
                            class="menu-item more"
                            :class="{ 'has-child': moreShow }"
                            @mouseenter="calcMoreStyle"
                        >
                            <a
                                class="iconfont icon-more"
                                style="font-size: 1.33em"
                                role="button"
                                tabindex="0"
                                :aria-label="$t('md-header.more')"
                                rel="noopener noreferrer"
                            ></a>
                            <div class="submenu-container">
                                <div class="wrapper" ref="wrapper">
                                    <ol
                                        class="submenu hidden-scrollbar"
                                        :style="moreStyle"
                                    >
                                        <menu-item
                                            v-for="(menu, index) in moreMenus"
                                            :key="menu.name + index"
                                            :menu="menu"
                                            isMore
                                            :showMenuArrow="true"
                                            arrowIcon="icon-fashion-down"
                                        ></menu-item>
                                    </ol>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <!-- google translate start -->
                    <template v-if="!isMobileSize">
                        <ul
                            v-if="showTranslatePlugin"
                            class="head-language-pc language"
                        >
                            <menu-item
                                :menu="translateMenu"
                                class="item-language"
                            >
                                <template v-slot:first>
                                    <span
                                        v-html="currentLanguageItem.label"
                                    ></span>
                                    <i class="iconfont icon-expand"></i>
                                </template>
                                <template v-slot:second="slotProps">
                                    <span
                                        @click="selectLanguage(slotProps.row)"
                                        class="lang-list-item"
                                    >
                                        <span>{{ slotProps.row.label }}</span>
                                    </span>
                                </template>
                            </menu-item>
                        </ul>
                        <ul
                            v-if="showCurrency"
                            class="head-language-pc currency"
                        >
                            <menu-item
                                :menu="curencyMenu"
                                class="item-language"
                            >
                                <template v-slot:first>
                                    <span>{{ currentCurrencyLabel }}</span>
                                    <i class="iconfont icon-expand"></i>
                                </template>
                                <template v-slot:second="slotProps">
                                    <span
                                        @click="selectCurrency(slotProps.row)"
                                        class="lang-list-item"
                                    >
                                        <span
                                        >{{ slotProps.row.abbr }}({{
                                            slotProps.row.symbol
                                        }})-{{ slotProps.row.name }}</span
                                        >
                                        <em
                                            v-show="
                                                currentCurrency ==
                                                    slotProps.row.abbr
                                            "
                                            class="iconfont icon-checked-light"
                                        ></em>
                                    </span>
                                </template>
                            </menu-item>
                        </ul>
                    </template>
                    <!-- google translate end -->
                    <ul class="head-account">
                        <li v-if="user" class="menu-item has-child">
                            <a
                                class="menu-user"
                                @click="hideMenu"
                                href="/profile"
                                rel="noopener noreferrer"
                            >
                                <span
                                    class="menu-user-initial"
                                    :style="{ background: userBackgroundColor }"
                                >{{ initialFirstName }}</span
                                >
                            </a>
                            <div class="wrapper">
                                <ol class="submenu">
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=MyHomes"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.myHomes') }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=MyTour"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.myTour') }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=Favorites"
                                            rel="noopener noreferrer"
                                        >{{
                                            $t('md-header.myFavorites')
                                        }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=Searches"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.mySearches') }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=Account"
                                            rel="noopener noreferrer"
                                        >{{
                                            $t('md-header.accountSettings')
                                        }}</a
                                        >
                                    </li>
                                    <li v-if="user.isOwner" class="menu-item">
                                        <a
                                            href="/admin/home"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.chimeCrm') }}</a
                                        >
                                    </li>
                                    <closely-app-download useModule="md-header" class="parent-dom-of-closely"/>
                                    <li class="menu-item">
                                        <a
                                            @click.prevent="logout"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.signOut') }}</a
                                        >
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <template v-else>
                            <li class="menu-item item-regist" role="button" tabindex="0" @click="register">
                                {{ $t('md-header.register') }}
                            </li>
                            <li class="menu-item item-login" role="button" tabindex="0" @click="signIn">
                                {{ $t('md-header.signIn') }}
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <div class="header-placeholder">
            <div :style="{ height: height }"></div>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </header>
</template>

<script>
import Common from '../index';
import scroll from '../scroll';
export default {
    mixins: [Common, scroll],
    computed: {
        height() {
            let fontsize = this.mainMenuText.fontSize.slice(0, -2);
            return (
                Math.max(
                    // 30 express logo up and down padding, 50 Represents the phone and mailbox column
                    (40 * this.size) / 100 + 30 + 50,
                    (40 * this.subLogoSize) / 100 + 30 + 50,
                    +fontsize + 52 + 50
                ) + 'px'
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '../variables.scss';

.md-header.template6 {
    color: #202437;
    position: relative;
    z-index: var(--level-medium);
    .header-container {
        position: fixed;
        display: flex;
        flex-wrap: wrap;
        left: 0;
        top: 0;
        width: 100%;
        z-index: var(--level-medium);
        padding: 0;
        font-size: 16px;
        font-family: var(--font-medium);
        letter-spacing: 1.1px;
        opacity: 1;
        transition: margin-left ease 0.3s, transform ease 0.3s,
            opacity ease 0.3s;
        user-select: none;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
        &.nosticky {
            position: absolute;
        }
        .menu-container {
            display: flex;
            width: 100%;
        }
        .social-container {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            background: #f6f7fb;
            .phone-container,
            .email-container {
                margin-left: 40px;
                cursor: pointer;
                .des {
                    color: #202437;
                    font-size: 14px;
                    font-family: var(--font-medium);
                    vertical-align: middle;
                }
                &:hover {
                    .iconfont {
                        background: rgba(0, 0, 0, 0.2);
                    }
                    .des {
                        text-decoration: underline;
                    }
                }
            }
            .share-container {
                margin-left: auto;
                margin-right: 40px;
                .share-item {
                    margin-right: 15px;
                    &:last-child {
                        margin-right: 0;
                    }
                    .iconfont {
                        margin-right: 0;
                    }
                }
            }
            .iconfont {
                height: 30px;
                width: 30px;
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.1);
                text-align: center;
                line-height: 30px;
                font-size: 14px;
                color: #515666;
                display: inline-block;
                margin-right: 10px;
                vertical-align: middle;
                cursor: pointer;
                &:hover {
                    background: rgba(0, 0, 0, 0.2);
                }
            }
        }
        .header-bg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: white;
            z-index: -1;
            opacity: $BG_OPACITY;
        }
        .logo {
            margin: 15px 30px 15px 40px;
            &:last-of-type {
                margin-right: 60px;
            }
            min-height: 40px;
            font-size: 40px;
            display: flex;
            align-items: center;
            img {
                height: 1em;
                display: block;
            }
        }
        .head-menu > .menu-item,
        .head-account > .menu-item {
            position: relative;
            vertical-align: middle;
            padding-right: 30px;
            flex: none;
            display: flex;
            align-items: center;
            > a {
                margin: 0px;
                padding: 26px 0;
                line-height: 1;
                .iconfont {
                    display: none;
                }
            }
            &:hover {
                > a {
                    color: var(--header-hovercolor);
                }
            }
            .submenu .menu-item {
                color: var(--header-sec-txtcolor, #515666);
            }
            .wrapper {
                display: none;
                position: absolute;
                padding: 0;
                min-width: 100%;
                z-index: 2;
                top: 100%;
                left: 0;
                color: var(--color-label);
                background: var(--header-sec-bgcolor, #fff);
                .menu-item {
                    position: static;
                    height: 40px;
                    line-height: 40px;
                    &:nth-of-type(1) {
                        margin-top: 10px;
                    }
                    &:nth-last-of-type(1) {
                        margin-bottom: 10px;
                    }
                    &:hover {
                        > a {
                            color: var(--header-hovercolor);
                        }
                        > .wrapper {
                            position: fixed;
                            width: auto;
                            min-width: 0;
                            left: auto;
                            display: block;
                        }
                    }
                }
                a {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 30px;
                    white-space: nowrap;
                    cursor: pointer;
                    @include ellipsis;
                    .iconfont {
                        display: inline-block;
                        &.icon-expand {
                            transform: rotate(-90deg);
                        }
                    }
                }
                .wrapper {
                    left: 100%;
                    top: 0;
                    margin-top: -10px;
                }
            }
            &:hover {
                cursor: pointer;
                > .submenu-container {
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    > .wrapper {
                        display: block;
                        position: relative;
                        left: -50%;
                    }
                }
                > .wrapper {
                    display: block;
                }
            }
        }
        .nav-container {
            display: flex;
            flex: 1;
        }
        .head-menu {
            display: flex;
            flex: 1;
            white-space: nowrap;
            .icon-lock {
                font-size: 14px;
                margin-left: 5px;
                vertical-align: middle;
            }
            .submenu {
                overflow: auto;
            }
            .more {
                display: none;
                padding-right: 30px;
                &.has-child {
                    display: flex;
                }
                .icon-more {
                    padding: 0 10px;
                    font-size: 16px;
                    line-height: 1;
                    vertical-align: middle;
                }
                > .wrapper {
                    .wrapper {
                        left: auto;
                        right: 100%;
                    }
                }
            }
        }
        .head-account {
            display: flex;
            flex: none;
            justify-content: flex-end;
            .parent-dom-of-closely {
                min-width: 240px;
                .download-closely {
                    background: #eeeeee;
                    border-radius: 5px;
                    width: calc(100% - 60px);
                    margin: 12px 30px;
                    padding: 15px 10px;
                    .code-title {
                        text-align: center;
                        color: #000;
                        line-height: 12px;
                    }
                    .code-wrapper {
                        .android,
                        .ios {
                            img {
                                width: 90px;
                                height: 90px;
                            }
                            span {
                                display: block;
                                text-align: center;
                                color: var(--header-sec-txtcolor, #000);
                            }
                        }
                        .android {
                            margin-left: 10px;
                        }
                    }
                }
            }
            > .menu-item {
                margin: 0;
                &.has-child {
                    padding-right: 30px;
                    .menu-user {
                        // max-width: 162px;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        .menu-user-initial {
                            width: 30px;
                            height: 30px;
                            border: 1px solid #fff;
                            border-radius: 50%;
                            background: var(--color-theme);
                            color: #ffffff;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            box-sizing: border-box;
                            text-transform: uppercase;
                            font-family: var(--font-medium);
                            font-size: 14px;
                        }
                    }
                    .wrapper {
                        text-align: right;
                        right: 30px;
                        left: auto;
                    }
                }
                &.item-login,
                &.item-regist {
                    cursor: pointer;
                    padding: 10px;
                    border: solid 2px #202437;
                    height: 36px;
                    line-height: 36px;
                    margin: auto;
                    text-transform: $SIGN_UPPERCASE;
                    font-family: var(--font-medium);
                    font-size: 14px;
                    &::before {
                        display: none;
                    }
                }
                &.item-login {
                    margin-right: 30px;
                    &:hover {
                        background: rgba(32, 36, 55, 0.3);
                    }
                }
                &.item-regist {
                    &:hover {
                        background: rgba(32, 36, 55, 0.1);
                    }
                }
            }
            > .menu-item + .menu-item {
                margin-left: 20px;
            }
        }
        .head-language-pc {
            display: flex;
            min-width: 95px;
            &.language {
                margin-right: 10px;
            }
            > .menu-item {
                // padding-right: 30px;
                margin-right: 30px;
                position: relative;
                vertical-align: middle;
                flex: none;
                display: flex;
                align-items: center;
                &:hover {
                    color: var(--header-hovercolor);
                    .icon-expand {
                        display: inline-block;
                        transform: rotate(180deg) translateY(3px);
                    }
                }
                .submenu .menu-item {
                    color: var(--header-sec-txtcolor, #515666);
                }
                .wrapper {
                    display: none;
                    position: absolute;
                    padding: 10px 0;
                    min-width: 100%;
                    z-index: 2;
                    top: 100%;
                    left: 0;
                    color: var(--color-label);
                    background: var(--header-sec-bgcolor, #fff);
                    .menu-item {
                        position: static;
                        height: 40px;
                        line-height: 40px;
                        &:hover {
                            color: var(--header-hovercolor);
                        }
                    }
                    .lang-list-item {
                        position: relative;
                        display: flex;
                        align-items: center;
                        padding: 0 30px;
                        white-space: nowrap;
                        cursor: pointer;
                        @include ellipsis;
                    }
                    .wrapper {
                        left: 100%;
                        top: 0;
                        margin-top: -10px;
                    }
                }
                &:hover {
                    cursor: pointer;
                    > .submenu-container {
                        position: absolute;
                        top: 100%;
                        left: 50%;
                    }
                    > .wrapper {
                        display: block;
                    }
                }
            }
        }
        .head-language-pc.currency {
            .wrapper {
                width: 320px;
                .lang-list-item {
                    display: flex !important;
                    justify-content: space-between;
                }
            }
        }
    }
    .header-placeholder {
        display: block;
        width: 100%;
        font-size: 40px;
        overflow: hidden;
        > div {
            height: 1em;
        }
    }
}
</style>
